import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const EfectivoInicioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='EFECTIVO INICIO' htmlFor='input-efectivoInicio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='efectivoInicio'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-efectivoInicio'
              placeholder='Ingresar monto ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(EfectivoInicioFormGroup)
